import { ContactEmail, ContactPhone, ContactValuesTranslation } from './contacts/types'

export interface Pagination {
    currentPage: number
    pageSize: number
    totalItems: number
    totalPages: number
}

export type ColumnOrder = Record<string, 'asc' | 'desc'>

export interface PageListParams<TCriteria = unknown> {
    page?: number
    limit?: number
    noLimit?: number
    order?: ColumnOrder
    criteria?: TCriteria
    contactId?: number
    module?: string
    collection?: string
}

export interface UpdateFileParams {
    id: string | number
    [key: string]: unknown
}
interface UpdateFileSuccess {
    data: { id: string | number }
}

export type UpdateFileResponse = UpdateFileSuccess | { error: Error }

export interface RouteParams {
    id: string
}

export interface DeleteMultipleResponse {
    successfulDelete: number[]
    notFoundIds: number[]
}

export enum ContactType {
    Person = 'person',
    Company = 'company',
}

export interface History {
    location: {
        hash?: string
        key?: string
        pathname: string
        search?: string
        state?: HistoryState
    }
    push: (path: string, state?: HistoryState) => void
}

export type HistoryState = {
    page?: number
    activeTab?: string
    profileId?: string
}

export interface ClonePropertyParams {
    id: string
    data: string[]
}
export interface ClonePropertyResponse {
    id: number
}

export interface FormValue {
    id: number
    name: string
    priority?: number
    translations?: ContactValuesTranslation[]
    visibility?: number
    active?: number
    companyOwner?: boolean
    companyLegalRepresentative?: boolean
    percentage?: string | null
}

export interface SelectOption {
    value: string
    label: string
}

export interface AsyncSelectOption {
    value: number
    label: string
    location?: string
}

export interface ContactAsyncSelectOption {
    value: number
    label: string
    data: {
        internalAppId: string | number | null // used in DOCUMENT_CONTACT_ID field
        contactEmail: unknown[]
        contactPersonCompany?: unknown[]
    }
}

// add more fields as needed
export interface Owner {
    contactCompany: {
        id: number
        name: string
    }
    contactPerson: {
        firstName: string
        lastName: string
    }
    contactType: string
    contactEmail: ContactEmail[]
    contactPhone: ContactPhone[]
    id: number
    internalAppId: number
}

export interface ApplicationLanguage {
    id: number
    name: string
    abbreviation: string
}

// Location data structure used across entities (property, contact, agent defaults, etc.)
// Some entities (like ContactProfile) use arrays for multi-select, others use single objects
export interface LocationSource {
    country?: { id?: number } | null
    county?: { id?: number } | { id?: number }[] | null
    city?: { id?: number } | { id?: number }[] | null
    widerArea?: { id?: number } | { id?: number }[] | null
    quarter?: { id?: number } | { id?: number }[] | null
    island?: { id?: number } | { id?: number }[] | null
}

export interface PermissionsProps {
    hasModulePermission?: boolean
    hasPermission?: boolean
    showMapsSlider?: boolean
}
